export default "__VITE_ASSET__xw6_jW09__"